module.exports = __webpack_public_path__ + "static/media/bg_common527f5150cc4f2b6f05d8773888222293.webp";